import { authContext, profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  Timezone,
  updateApplicantResumeProfileRoute,
  updateEmployerProfileRoute,
  updateEnterpriseCompanyResponsesRoute,
} from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type useUpdateEnterpriseUpdateCompanyProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

type CommonFields = {
  timezone?: Timezone;
};

type EmployerFields = {
  walkthrough_completed?: boolean;
  default_request_more_info_message?: string;
  default_open_interview_message?: string;
  default_interview_message?: string;
  default_saved_message?: string;
  default_declined_message?: string;
  default_hire_message?: string;
  default_archive_message?: string;
  keep_declined_applications?: number | 'Never';
  keep_unattended_applications?: number | 'Never';
  unresponsive_message?: number | 'Never';
  unresponsive_interview?: number | 'Never';
  mon_availability?: number;
  tues_availability?: number;
  wed_availability?: number;
  thurs_availability?: number;
  fri_availability?: number;
  sat_availability?: number;
  sun_availability?: number;
  s_name?: string;
  s_email?: string;
  s_phone?: string;
  company_id?: string | number;
};

type ApplicantFields = {
  employment_status?: string;
};

export const useUpdateEnterpriseUpdateCompany = ({
  setErrorText = () => { },
  onSuccess = () => { },
}: useUpdateEnterpriseUpdateCompanyProps) => {
  const {
  } = useContext(authContext);

  const client = useQueryClient();

  const { mutate: updateCompanyResponses, isLoading: isUpdatingCompanyResponses } = useMutation({
    mutationFn: (variables: CommonFields | EmployerFields | ApplicantFields) =>
      axiosInstance
        .post(updateEnterpriseCompanyResponsesRoute,
          variables,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([profileKey]);

        onSuccess();
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    updateCompanyResponses,
    isUpdatingCompanyResponses,
  };
};
